import { Card } from '@mews-commander/ui';
import { Highlight, IconList, IconListItemProps, IconName, Link, Stack } from '@optimus-web/core';
import { lt, useFeatureFlag, useOpenAdaChat } from '@mews/framework';
import { FeatureFlag } from '@mews-commander/enums';

interface GetIconListItemsParams {
    handleAdaChatClick: () => Promise<void>;
    showAdaChatListItem: boolean;
}

const getIconListItems = ({ handleAdaChatClick, showAdaChatListItem }: GetIconListItemsParams) =>
    [
        {
            key: 'university',
            label: (
                <Link
                    icon={IconName.ExternalLink}
                    underline={false}
                    variant="basic"
                    href="https://university.mews.com"
                    target="_blank"
                    rel="noreferrer"
                >
                    {lt('OnboardingAuditHelpAndSupportItemUniversityLabel')}
                </Link>
            ),
            description: lt('OnboardingAuditHelpAndSupportItemUniversityDescription'),
            icon: IconName.Education,
            variant: 'basic',
        },
        {
            key: 'help',
            label: (
                <Link
                    icon={IconName.ExternalLink}
                    underline={false}
                    variant="basic"
                    href="https://help.mews.com"
                    target="_blank"
                    rel="noreferrer"
                >
                    {lt('OnboardingAuditHelpAndSupportItemHelpLabel')}
                </Link>
            ),
            description: lt('OnboardingAuditHelpAndSupportItemHelpDescription'),
            icon: IconName.Help,
            variant: 'basic',
        },
        {
            key: 'community',
            label: (
                <Link
                    icon={IconName.ExternalLink}
                    underline={false}
                    variant="basic"
                    href="https://community.mews.com"
                    target="_blank"
                    rel="noreferrer"
                >
                    {lt('OnboardingAuditHelpAndSupportItemCommunityLabel')}
                </Link>
            ),
            description: lt('OnboardingAuditHelpAndSupportItemCommunityDescription'),
            icon: IconName.Countries,
            variant: 'basic',
        },
        ...(showAdaChatListItem
            ? [
                  {
                      key: 'ada',
                      label: (
                          <Link
                              onClick={async () => handleAdaChatClick()}
                              icon={IconName.ExternalLink}
                              underline={false}
                              variant="basic"
                          >
                              {lt('OnboardingAuditHelpAndSupportItemAdaLabel')}
                          </Link>
                      ),
                      description: lt('OnboardingAuditHelpAndSupportItemAdaDescription'),
                      icon: IconName.CustomerSuccess,
                      variant: 'basic',
                  } as IconListItemProps,
              ]
            : []),
    ] satisfies IconListItemProps[];

export const HelpSupport = () => {
    const handleAdaChatClick = useOpenAdaChat();
    const isAdaEmbeddedFeatureFlagEnabled = useFeatureFlag(FeatureFlag.adaEmbeddedFeatureFlagEnabled);
    const isAdaChatBotV2Enabled = useFeatureFlag(FeatureFlag.adaChatBotV2Enabled);
    const showAdaChatListItem = isAdaEmbeddedFeatureFlagEnabled && isAdaChatBotV2Enabled;

    return (
        <Card padding="300">
            <Stack spacing="250" vertical>
                <Highlight size="small">{lt('OnboardingAuditHelpAndSupportSectionTitle')}</Highlight>
                <IconList small items={getIconListItems({ handleAdaChatClick, showAdaChatListItem })} />
            </Stack>
        </Card>
    );
};
